import jQuery from "vendor/jquery";
import $ from "vendor/jquery";
import handlebarsRuntime from "vendor/handlebars-runtime";
import hb from "vendor/handlebars-runtime";
import spartaStyleUtility from "global/sparta-style-utility";
import Module from "global/sparta-module-utility";
import spartaTemplates from "modules/community/connect-with-us-module/2.1.0/js/templates";
import "css!modules/community/connect-with-us-module/2.1.0/css/connect-with-us-module.scss.css";
/* global Module */

/*
 * connect-with-us-module
 * module_js_id: connectWithUsModuleJS
 *
 * Copyright (c) 2017-3-31 Josh Peal
 */

export default class connectWithUsModuleJS extends Module {
  constructor(options) {
    super(options);
  }

  init(args = {}) {
    const $clickableBlocks = this.settings.$target.find('.block-container.clickable');

    // allow accordion behaviour
    $clickableBlocks.find('.accordion-trigger').on('click', function () {
      const $accordionContainer = $(this).closest('.content-container').find('.content').first();
      $accordionContainer.slideToggle();
      this.classList.toggle('expanded');
    });

    // prevent bubbling to avoid double clicks
    $clickableBlocks.on('click', '.title-link, button', (e) => {
      e.stopPropagation();
    });

    // handle clicks on blocks
    $clickableBlocks.click( function () {
      let titleLink = false;
      const $block = $(this);
      const $chatContainer = $block.find('.chat-container');
      if ($chatContainer.length !== 0) {
        // this is a chat box with a button injected by Nuance 3d party service
        titleLink = $chatContainer.find('button')[0];
      } else {
        // check for regular title links
        titleLink = $block.find('.title-link')[0];
      }

      if (titleLink) {
        titleLink.click();
      }
    });
  }
}
